var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOndemandVideo = function SvgOndemandVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "24px",
    viewBox: "0 0 28 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ondemand_video-24px")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1314.000000, -743.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ondemand_video-24px",
    transform: "translate(1313.000000, 740.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 30 0 30 30 0 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25,3.75 L3.75,3.75 C2.3625,3.75 1.25,4.8625 1.25,6.25 L1.25,21.25 C1.25,22.625 2.3625,23.75 3.75,23.75 L10,23.75 L10,26.25 L20,26.25 L20,23.75 L26.25,23.75 C27.625,23.75 28.7375,22.625 28.7375,21.25 L28.75,6.25 C28.75,4.8625 27.625,3.75 26.25,3.75 Z M26.25,21.25 L3.75,21.25 L3.75,6.25 L26.25,6.25 L26.25,21.25 Z M20,13.75 L11.25,18.75 L11.25,8.75 L20,13.75 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOndemandVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ondemand-video.146603f6.svg";
export { ForwardRef as ReactComponent };